var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookGs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-2",
    transform: "translate(0 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u0412\\u044B\\u0447\\u0438\\u0442\\u0430\\u043D\\u0438\\u0435_18",
    "data-name": "\\u0412\\u044B\\u0447\\u0438\\u0442\\u0430\\u043D\\u0438\\u0435 18",
    d: "M24,48A24.006,24.006,0,0,1,14.659,1.886,24,24,0,0,1,40.97,40.971,23.922,23.922,0,0,1,24,48Zm-3.02-24.039V35.954H25.5V23.961h3.707l.713-4.476H25.5V18.109a1.476,1.476,0,0,1,1.418-1.586h3.094V11.954H26.377v.018c-2.028.072-3.44.628-4.315,1.7A5.637,5.637,0,0,0,20.989,17.2v0l-.008,0v2.281h-3v4.476Z",
    transform: "translate(0 -0.2)",
    fill: "#bfbdc5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGs);
export default __webpack_public_path__ + "static/media/facebook-gs.6a4f1e4d74ce4810a9c8849693066cb7.svg";
export { ForwardRef as ReactComponent };